import { MODULE as PARENT } from '../constants'

export const KEY = 'company'
export const MODULE = [...[PARENT], KEY]

export const FETCH_COMPANY = `${KEY}-fetch`
